import {
    LOADING_SUBSCRIBTION,
    CHECK_SUBSCRIBTION,
    GET_SUBSCRIBTION,
    CANCEL_SUBSCRIBTION
} from '../constants';

const initialState = {
    remainingDay: '',
    subscriptionId: '',
    planId: '',
    subscriptionStaus: false,
    showLoading: false,
};

export function SubscribtionReducer(state = initialState, action) {

    if (action.type === CHECK_SUBSCRIBTION) {
        return {
            ...state,
            subscriptionStaus: action.payload.expired,
            remainingDay: action.payload.remaining_day,
            subscriptionId: action.payload.subscriptionId,
            planId: action.payload.planId,
            showLoading: false,
        };
    }

    if (action.type === CANCEL_SUBSCRIBTION) {
        return {
            ...state,
            subscriptionStaus: action.payload.expired,
            remainingDay: action.payload.remaining_day,
            showLoading: false,
        };
    }

    if (action.type === GET_SUBSCRIBTION) {
        return {
            ...state,
            showLoading: false,
        };
    }

    if (action.type === LOADING_SUBSCRIBTION) {
        return {
            ...state,
            showLoading: action.payload,
        };
    }
    return state;
}


